export default "__VITE_ASSET__12a49619__"